/**
 * Which late Visits a Service Plan group row's "Reschedule all" and "Skip all" hand to the server queue.
 * Age is the gate: a Current Visit already has the per-record Reschedule and Skip.
 */
import { VisitAgeState, VisitBrowseRow, visitBrowseCapabilities } from '@jms/model';
import { visitDatesEditable } from '../commands/visit.dates.command.support';
import { visitPlanNotStartedReason } from '../visit.model';

/** An Overdue or Missed Visit whose appointment the dates command may still move. */
export function reschedulable(row: VisitBrowseRow): boolean {

  return aged(row) && visitDatesEditable(row);
}

/** An Overdue or Missed Visit of a Started plan that Skip accepts. */
export function skippable(row: VisitBrowseRow): boolean {

  return aged(row) && visitBrowseCapabilities(row).skip && !visitPlanNotStartedReason(row);
}

function aged(row: VisitBrowseRow): boolean {

  return row.ageState === VisitAgeState.Overdue || row.ageState === VisitAgeState.Missed;
}
